import logo from "../assets/images/logo.png"
import logo_c from "../assets/images/company_logo.png"
export default {
    home: {
        welcome1: '諦視者',
        welcome2: '書庫',
        logo,
        lang: [
            {
                title: '繁體中文',
                key: 'zh-tw'
            },
            {
                title: '简体中文',
                key: 'zh-cn'
            },
            {
                title: 'English',
                key: 'en'
            },
            {
                title: '日本語',
                key: 'ja'
            },
            {
                title: '한국어',
                key: 'ko'
            }

        ],
        reward: "專屬獎勵",
        welfare: "限定福利",
        up: "查看活動說明",
        activity: {
            time: {
                title: "活動時間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 10:00",
                month_day_end: "02月03日 10:00",
            },
            content: {
                title: "活動方式：",
                way: [
                    `1、點擊【專屬獎勵】即可領取《Sdorica 萬象物語》X《地下城物語》聯動專屬獎勵一份。`,
                    `2、點擊【限定福利】進入聯動活動頁面領取更多獎勵。`,
                    `3、本頁面僅可領取聯動活動《Sdorica 萬象物語》獎勵內容。`,
                    `4、欲領取《地下城物語》獎勵請前往《地下城物語》相關活動頁。`,
                    `5、每一個SID中的個別書庫帳號均可領取一次獎勵，點擊領取後獎勵將直接發送到當前登錄的書庫中。`,
                    `6、獎勵將透過遊戲內信件發送，信件有效期為30天，領取完畢後請確認是否領取。`
                ]
            }
        }
    },
    welfare: {
        back: "回到首頁",
        welcome1: '諦視者',
        welcome2: '書庫',
        gumballs_activity: {
            time: {
                title: "活動時間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 10:00",
                month_day_end: "02月03日 10:00",
            },
            content: {
                title: "活動方式：",
                way: [
                    `1、點擊【領取《地下城物語》活動序號】即可領取《地下城物語》聯動限定活動序號。`,
                    `2、點擊【下載《地下城物語》】下載並安裝《地下城物語》。`,
                    `3、開啟並前往《地下城物語》大地圖>右上角齒輪設置>密令兌換`
                ]
            },
            get_code: "領取《地下城物語》活動序號",
            download: "下載《地下城物語》"
        },
        sdorica_activity: {
            time: {
                title: "活動時間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 10:00",
                month_day_end: "02月03日 10:00",
            },
            content: {
                title: "活動方式：",
                way: [
                    `1、前往《地下城物語》聯動活動頁領取《Sdorica 萬象物語》聯動限定活動序號。`,
                    `2、在以下輸入框中輸入，並點擊領取。`,
                    `3、每一個SID中的個別書庫帳號僅可領取一次。`,
                    `4、請確認書庫名稱、遊戲暱稱無誤後再進行領取，領取成功後該序號不得再次使用。`,
                    `5、獎勵內容將透過遊戲內信件發送，信件有效期為30天，領取完畢後請確認是否領取。`
                ]
            },
            label: "活動序號：",
            placeholder: "點擊輸入活動序號",
            noEnter_placeholder: "請先輸入活動序號",
            get_welfare: "領取《Sdorica 萬象物語》限定福利",
            got_welfare: "已領取限定福利"
        }
    },
    get_reward: {
        done: {
            title: "領取成功！",
            content: ["獎勵已寄送至遊戲中信箱，","請至遊戲中確認"]
        },
        failed: {
            title: "領取失敗！",
            retry:"請重試"
        },
    },
    code_config: {
        title: "《地下城物語》限定活動序號",
        copy: "複製",
        download: "下載《地下城物語》，前往對應的活動頁使用",
        success: '複製成功'

    },
    rightCode: '請輸入正確的活動序號',
    messageFailed: "已領取，請勿重複領取",
    footer: {
        logo: logo_c,
        company: "© 2019 Rayark Inc. All rights reserved.",
        caseNumber: "",
        copyright: "",
        publicSecurityRecordNumber: "",
        wangwen: ""

    },
    resize: '請將手機/平板調整為直向觀看。',
    notFound: '抱歉，頁面不存在。',
    network_error: {
        INVALID_REWARD_TYPE: '非正確的獎勵',
        EXIST_REWARD_RECORD: '已領取獎勵',
        INVALID_CODE: '該序號驗證失敗',
        CODE_USED: '該序號已被使用',
        GAMEDATA_INVALID_VALUE: '領取失敗',
        OTHER:'領取失敗',
        NO_TOKEN:'本頁面需要從遊戲內點擊活動宣傳圖進入'
    }

}